import { strikeZones } from "../../strike-zones";

export const weapons: Record<
  string,
  {
    damage: number;
    type: string;
    range: number;
    detection: number;
    cooldown: number;
    projectileSpeed?: number;
    areaRadius?: number;
    homing?: boolean;
    minRange?: number;
    antiAir?: boolean;
    airOnly?: boolean;
    airDamageMultiplier?: number;
  }
> = {
  hoverRockets: {
    airDamageMultiplier: 5,
    damage: 12,
    type: "rocket",
    range: 240,
    detection: 280,
    cooldown: 1,
    projectileSpeed: 420,
    homing: true,
    antiAir: true,
  },
  bomb: {
    damage: 300,
    type: "bombing",
    range: 40,
    detection: 200,
    cooldown: 0.25,
    projectileSpeed: 200,
    areaRadius: 72,
  },
  sam: {
    damage: 100,
    type: "rocket",
    range: 300,
    detection: 320,
    cooldown: 0.85,
    projectileSpeed: 520,
    homing: true,
    antiAir: true,
    airOnly: true,
  },
  dronePayload: {
    damage: 420,
    type: "precision",
    range: 32,
    detection: 32,
    cooldown: 1,
    areaRadius: 60,
  },
  missilePayload: {
    damage: 1600,
    type: "missile",
    range: 120,
    detection: 120,
    cooldown: 240,
    areaRadius: strikeZones.missileFalloffRadius,
  },
  bombard: {
    damage: 200,
    type: "artillery",
    range: 420,
    minRange: 120,
    detection: 420,
    cooldown: 3.5,
    projectileSpeed: 450,
    areaRadius: 64,
  },
  rifle: {
    antiAir: true,
    damage: 12,
    type: "bullet",
    range: 130,
    detection: 200,
    cooldown: 0.6,
  },
  launcher: {
    antiAir: true,
    airDamageMultiplier: 0.5,
    damage: 65,
    type: "rocket",
    projectileSpeed: 420,
    homing: true,
    range: 170,
    detection: 230,
    cooldown: 1.5,
  },
  machineGun: {
    damage: 24,
    type: "autogun",
    range: 150,
    detection: 240,
    cooldown: 0.6,
  },
  grenade: {
    damage: 40,
    type: "explosive",
    range: 150,
    detection: 220,
    cooldown: 1.8,
    projectileSpeed: 260,
    areaRadius: 32,
    homing: false,
  },
  heavyCannon: {
    damage: 80,
    type: "cannon",
    range: 200,
    detection: 260,
    cooldown: 1.7,
    projectileSpeed: 520,
    areaRadius: 10,
    homing: false,
  },
  towerGun: {
    damage: 18,
    type: "bullet",
    range: 280,
    detection: 300,
    cooldown: 0.2625,
  },
};

export const damageTable: Record<string, Record<string, number>> = {
  precision: { infantry: 0.12, light: 0.8, heavy: 1, building: 0.45 },
  bombing: { infantry: 0.55, light: 0.4, heavy: 0.5, building: 1.4 },
  missile: { infantry: 0.15, light: 0.2, heavy: 0.2, building: 1 },
  autogun: { infantry: 1, light: 0.6, heavy: 0.2, building: 0.1 },
  bullet: { infantry: 1, light: 0.35, heavy: 0.1, building: 0.1 },
  rocket: { infantry: 0.15, light: 0.75, heavy: 1, building: 0.5 },
  cannon: { infantry: 0.3, light: 1, heavy: 0.9, building: 0.8 },
  explosive: { infantry: 1, light: 0.6, heavy: 0.3, building: 0.75 },
  // Artillery: strong against structures and armies.
  artillery: { infantry: 1.0, light: 0.7, heavy: 0.5, building: 1.5 },
};
